import React, { useState, useEffect } from 'react';
import '../actividades/log_actividades.css';
import apiServices from '../../../actions/services';
import { useSelector } from 'react-redux';

const LogLastActivity = () => {
    const { user } = useSelector(state => state.auth);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Función para cargar los datos desde la API
  const fetchData = async () => {
    try {
      setError(null);
      // Reemplaza con la URL de tu API real
      const dat = {};
      const response = await apiServices.get("LogActivity",dat,user);
      console.log("Respuesta",response.datos_Generados);
    //   if (!response.ok) 
    //     {
    //     throw new Error('Error al cargar los datos');      
    //     }
        //console.log("Variable Generados: ", response.datos_Generados);
      const data = JSON.parse(response.datos_Generados );
      console.log("Variable DATA: ", data);
      setUsers(data);
      setFilteredUsers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Filtrar usuarios basado en el término de búsqueda
  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    
    if (term === '') {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(user => 
        user.Pantalla.includes(term) ||
        user.Usuario.includes(term) ||
        user.Nombre_Completo.includes(term) ||
        user.Estado_Conexion.includes(term) ||
        user.TiempoTranscurrido.includes(term) ||
        user['Ultimo Log'].includes(term)
      );
      setFilteredUsers(filtered);
    }
  };

  // Formatear fecha para mejor legibilidad
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-ES');
  };

  // Cargar datos iniciales y configurar auto-refresh
  useEffect(() => {
    fetchData(); // Carga inicial
    
    // Configurar auto-refresh cada minuto
    const interval = setInterval(fetchData, 60000);
    
    // Limpiar intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, []);

  // Actualizar filtro cuando cambian los usuarios
  useEffect(() => {
    if (searchTerm) {
      handleSearch({ target: { value: searchTerm } });
    } else {
      setFilteredUsers(users);
    }
  }, [users]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando datos de usuarios...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-message">
          <h3>Error al cargar los datos</h3>
          <p>{error}</p>
          <button onClick={fetchData} className="retry-button">
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="log-last-activity">
      <div className="header">
        <h1>Actividad de Usuarios</h1>
        <div className="controls">
          <div className="search-container">
            <input
              type="text"
              placeholder="Buscar en todos los campos..."
              value={searchTerm}
              onChange={handleSearch}
              className="search-input"
            />
            <span className="search-icon">🔍</span>
          </div>
          <div className="stats">
            <span>Total: {filteredUsers.length} usuarios</span>
            <span className="last-update">
              Última actualización: {new Date().toLocaleTimeString()}
            </span>
          </div>
        </div>
      </div>
      {/* table-container */}
      <div className="">
        <table className="users-table">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Nombre Completo</th>
              <th>Pantalla</th>
              <th>Último Log</th>
              <th>Estado Conexión</th>
              <th>Tiempo Transcurrido</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">
                  No se encontraron usuarios que coincidan con la búsqueda
                </td>
              </tr>
            ) : (
              filteredUsers.map((user, index) => (
                <tr key={index} className={user.Estado_Conexion === 'ACTIVO' ? 'active' : 'inactive'}>
                  <td className="username">{user.Usuario}</td>
                  <td className="fullname">{user.Nombre_Completo}</td>
                  <td className="screen">{user.Pantalla}</td>
                  <td className="last-log">{formatDate(user['Ultimo Log'])}</td>
                  <td className="status">
                    <span className={`status-badge ${user['Estado Conexion'].toLowerCase()}`}>  
                      {user['Estado Conexion']}
                     </span> 
                  </td>
                  <td className="elapsed-time">{user.TiempoTranscurrido}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LogLastActivity;